import { useState } from "react";

import { Currency } from "@sso/types";
import { StyledSelect } from "@sso/ui/StyledSelect";

import { SelectDataType } from "../Form";

interface CurrencySelectProps {
  currencyCode?: string;
  onCurrencyChange?: (currencyCode: string) => void;
  currencies: Currency[];
}

const CurrencySelect = ({ currencyCode, onCurrencyChange, currencies }: CurrencySelectProps) => {
  const priorityCodes = ["GBP", "USD", "EUR"];

  let items: SelectDataType[] = [];
  let initialSelectedCode = currencyCode;

  if (currencies.length === 0) {
    items = [
      {
        key: "-1",
        value: "-1",
        label: "Could not load currencies",
      },
    ];
    initialSelectedCode = "-1";
  } else {
    const sortedCurrencies = [
      ...currencies
        .filter(c => priorityCodes.includes(c.code))
        .sort((a, b) => priorityCodes.indexOf(a.code) - priorityCodes.indexOf(b.code)),

      ...currencies.filter(c => !priorityCodes.includes(c.code)).sort((a, b) => a.name.localeCompare(b.name)),
    ];

    items = sortedCurrencies.map(c => ({
      key: c.code,
      value: c.code,
      label: `${c.name} ${c.code} ${c.symbol}`,
    }));
  }

  const [selectedCode, setSelectedCode] = useState(initialSelectedCode);

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCode = e.target.value;
    setSelectedCode(newCode);
    if (onCurrencyChange && newCode !== "-1") {
      onCurrencyChange(newCode);
    }
  };

  return (
    <StyledSelect id="currency-select" value={selectedCode} onChange={onChange}>
      {items.map(item => (
        <option key={item.key} value={item.value}>
          {item.label}
        </option>
      ))}
    </StyledSelect>
  );
};

export default CurrencySelect;
